import { Injectable } from "@angular/core";
import { Headers, Http, Response } from "@angular/http";
import "rxjs/add/operator/toPromise";
import { webapi } from "../../shared/my-constants";

@Injectable()
export class MbillPackageService {
  private headers = new Headers({ "Content-Type": "application/json" });
  private ListRecord = webapi + "mbill_package/list/?";
  private ListRecordNameTariff = webapi + "mbill_package/listbynametariff/?";
  private ListRecordPckgServTariffClass =
    webapi + "mbill_package/listbypckservtariffclass/?";
  private ListRecordPckgServTariffClass1 = webapi + "mbill_package/byid/";
  private AddRecord = webapi + "mbill_package/create";
  private UpdateRecord = webapi + "mbill_package/update";
  private DeletedPackageService =
    webapi + "mbill_package/deletedPackageService/";
  private AddRecordPackageService = webapi + "mbill_package_service/create";
  private EditRecord = webapi + "mbill_package/update";
  private GetRecord = webapi + "mbill_package/byMbillPackageid/";
  // private GetRecord = webapi + 'mbill_package/byid/';
  private DeleteRecord = webapi + "mbill_package/delete/";
  private getRecordByPackageId =
    webapi + "mbill_package_service/listservicebypackage/?";
  private ReActiveRecord = webapi + "mbill_package/reActive/";
  private DeListRecord = webapi + "mbill_package/deactivated_list/?";

  constructor(private http: Http) {}
  getAllDeactivatedRecordService(
    currentPage: any,
    size: any,
    qString: any,
    sort: any,
    col: any
  ): Promise<any> {
    // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col);
    return this.http
      .get(
        this.DeListRecord +
          "page=" +
          currentPage +
          "&size=" +
          size +
          "&qString=" +
          qString +
          "&sort=" +
          sort +
          "&col=" +
          col
      )
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }
  reActiveRecordService(id: any) {
    return this.http
      .put(this.ReActiveRecord + id, { headers: this.headers })
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  getAllRecordService(
    currentPage: any,
    size: any,
    qString: any,
    sort: any,
    col: any
  ): Promise<any> {
    return this.http
      .get(
        this.ListRecord +
          "page=" +
          currentPage +
          "&size=" +
          size +
          "&qString=" +
          qString +
          "&sort=" +
          sort +
          "&col=" +
          col
      )
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTariffAndPackageName(
    packageName: any,
    tariffId: any,
    classId: any
  ): Promise<any> {
    return this.http
      .get(
        this.ListRecordNameTariff +
          "qstring=" +
          packageName +
          "&packageTarrifId=" +
          tariffId
      )
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  getAllRecordByPckServAndTariffAndClass1(
    serviceId: number,
    tariffId: number,
    classId: number
  ) {
    return this.http
      .get(
        this.ListRecordPckgServTariffClass1 +
          serviceId +
          "/" +
          tariffId +
          "/" +
          classId
      )
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  getAllRecordByPckServAndTariffAndClass(
    serviceId: number,
    tariffId: number,
    classId: number
  ) {
    return this.http
      .get(
        this.ListRecordPckgServTariffClass +
          "serviceId=" +
          serviceId +
          "&tariffId=" +
          tariffId +
          "&classId=" +
          classId
      )
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  getAllRecordByPackageId(packageId: any, classId: any): Promise<any> {
    return this.http
      .get(
        this.getRecordByPackageId +
          "packageid=" +
          packageId +
          "&classid=" +
          classId
      )
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  addRecordPackageService(model: any) {
    return this.http
      .post(this.AddRecordPackageService, JSON.stringify(model), {
        headers: this.headers,
      })
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http
      .post(this.AddRecord, JSON.stringify(model), { headers: this.headers })
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  updateService(model: any) {
    return this.http
      .post(this.UpdateRecord, JSON.stringify(model), { headers: this.headers })
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  deletedPackageService(packageId: any, serviceId: any) {
    return this.http
      .get(this.DeletedPackageService + packageId + "/" + serviceId)
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http
      .put(this.EditRecord, JSON.stringify(model), { headers: this.headers })
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  // deleteRecordService(id: any) {
  //   return this.http.put(this.DeleteRecord + id, {headers: this.headers})
  //     .toPromise()
  //     .then(response => response.json())
  //     .catch(this.handleError);
  // }
  deleteRecordService(id: any) {
    return this.http
      .put(this.DeleteRecord + id, { headers: this.headers })
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http
      .get(this.GetRecord + id)
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mbill-package/mbill-package.service.ts